export default __webpack_public_path__ + "static/media/mus-worldclasscinema.ef89b305.mp4";